/**
 * Strings for custom server emoji (2026-11-01): Server settings > Emoji,
 * the picker's server section, the composer's :emoji suggestions, the
 * permissions that go with them, their audit lines and their errors.
 */
import type { Dict } from './core';

export const emojiEn: Dict = {
  // ---- Server settings > Emoji
  'emo.tab': 'Emoji',
  'emo.intro':
    'Add up to 50 emoji and 50 animated emoji that everyone in the server can use in messages and reactions. Type :name: to use one.',
  'emo.req.title': 'Upload requirements',
  'emo.req.type': 'File type: PNG, GIF or WebP',
  'emo.req.size': 'Bigger images are shrunk to fit 128 × 128 and 256 KB',
  'emo.req.name': 'Names: 2 to 32 characters, lowercase letters, numbers and _',
  'emo.req.anim': 'An animated GIF or WebP stays animated',
  'emo.upload': 'Upload emoji',
  'emo.uploading': 'Uploading…',
  'emo.uploaded': 'Added :{name}:',
  'emo.still': 'Emoji',
  'emo.animated': 'Animated emoji',
  'emo.slots': '{n} of {max} slots free',
  'emo.empty': 'No emoji yet.',
  'emo.col.image': 'Image',
  'emo.col.name': 'Name',
  'emo.col.by': 'Uploaded by',
  'emo.nameOf': 'Name of :{name}:',
  'emo.by': 'By {name}',
  'emo.delete': 'Delete :{name}:',
  'emo.deleteTitle': 'Delete :{name}:?',
  'emo.deleteBody':
    'It disappears from the picker and from messages. Reactions with it stay, without the image.',
  'emo.deleteOk': 'Delete',
  'emo.deleted': 'Deleted :{name}:',
  'emo.renamed': 'Renamed to :{name}:',
  'emo.full': 'This server has no emoji slots left.',
  'emo.off': 'Custom emoji are turned off by the admins right now. You can still delete them.',
  'emo.err.type': 'Emoji can be PNG, GIF or WebP images.',
  'emo.err.name': 'Use 2 to 32 lowercase letters, numbers or _.',
  'emo.err.taken': 'Another emoji has this name.',
  // ---- the picker, the composer, reactions
  'emo.server': 'This server',
  'emo.suggest.title': 'Emoji matching :{q}',
  'emo.suggest.server': 'Server emoji',
  'emo.deletedEmoji': 'Deleted emoji',
  // ---- the audit log
  'emo.audit.create': '{actor} added the emoji :{name}:',
  'emo.audit.update': '{actor} renamed the emoji :{old}: to :{name}:',
  'emo.audit.delete': '{actor} deleted the emoji :{name}:',
  'emo.audit.f.create': 'Emoji added',
  'emo.audit.f.update': 'Emoji renamed',
  'emo.audit.f.delete': 'Emoji deleted',
  // ---- permissions (Discord's names)
  'ns.perm.CREATE_GUILD_EXPRESSIONS': 'Create expressions',
  'ns.permd.CREATE_GUILD_EXPRESSIONS':
    'Lets members add custom emoji to this server, and rename or delete the ones they added.',
  'ns.perm.MANAGE_GUILD_EXPRESSIONS': 'Manage expressions',
  'ns.permd.MANAGE_GUILD_EXPRESSIONS':
    'Lets members rename or delete any custom emoji in this server.',
  // ---- errors (Discord's codes)
  'ns.err.10014': 'That emoji no longer exists.',
  'ns.err.30008': 'This server has no emoji slots left (50).',
  'ns.err.30018': 'This server has no animated emoji slots left (50).',
  'cfg.off.custom_emoji': 'Custom emoji are turned off by the admins right now.',
};
